import 'css-chunksrc/client/pages/projectPage/resourcesPage/toggleViewButton/styles.scss';export default {
  "toggleViewButton": "_toggleViewButton_12d0q_1",
  "active": "_active_12d0q_15",
  "toggle": "_toggle_12d0q_1"
};